import { StyleVariableValueValue } from '@wix/document-services-types';
import {
  ShadowStyleValue,
  SpacingStyleValue,
  CoordinatesStyleValue,
  GapShorthandValue,
} from '../../types';
import { Padding } from '@wix/document-services-types/src/style/layout';

const isSpacingCoordinatesValue = (
  value: StyleVariableValueValue | undefined,
): value is CoordinatesStyleValue => {
  // @ts-expect-error - TODO: ds-types-bump
  return value?.type === 'Coordinates';
};

export const isGapShorthandValue = (
  value: StyleVariableValueValue | undefined,
): value is GapShorthandValue => {
  // @ts-expect-error - TODO: ds-types-bump
  return value?.type === 'Gap';
};

const isCoordinatesPaddingValue = (
  value: CoordinatesStyleValue,
  // @ts-expect-error - TODO: ds-types-bump
): value is Padding => {
  return (
    // @ts-expect-error - TODO: ds-types-bump
    value.left?.type === 'Length' ||
    // @ts-expect-error - TODO: ds-types-bump
    value.right?.type === 'Length' ||
    // @ts-expect-error - TODO: ds-types-bump
    value.top?.type === 'Length' ||
    // @ts-expect-error - TODO: ds-types-bump
    value.bottom?.type === 'Length'
  );
};

export const isPaddingValue = (
  value: StyleVariableValueValue | undefined,
  // @ts-expect-error - TODO: ds-types-bump
): value is Padding => {
  return isSpacingCoordinatesValue(value) && isCoordinatesPaddingValue(value);
};

export const isSpacingStyleValue = (
  value: StyleVariableValueValue | undefined,
): value is SpacingStyleValue => {
  // @ts-expect-error - TODO: ds-types-bump
  return value?.type === 'Length';
};

export const isShadowStyleValue = (
  value: StyleVariableValueValue | undefined,
): value is ShadowStyleValue => {
  // @ts-expect-error - TODO: ds-types-bump
  return value?.type === 'BoxShadow';
};

export const defaultValueSet = (value: string | undefined): value is string => {
  return valueSet(value);
};

export function valueSet<T>(v: T | undefined | null): v is T {
  return v !== undefined && v !== null;
}
